import { getLegalApi } from './legal-api';
import { create } from '@eureka/utils/deferred'
import _ from 'lodash';

const deferred = create();

getLegalApi().then(res => {
    deferred.resolve(res)
})

export async function useLegalStatus(code?: number|string, lang = 'en') {
    const { simpleLegalStatus } = await deferred.promise
    if (code === undefined || code === null) return
    const currentLegalInfo = _.get(simpleLegalStatus, code)
    if (!currentLegalInfo) return;
    return {
        color: currentLegalInfo.color,
        text: _.get(currentLegalInfo.title, lang) as string,
    };
}
